import ApplicationController from "./application_controller";

export default class extends ApplicationController {

  static targets = ["menu"];
  connect() {
    console.log("did connect DropdownController");
  }
  toggle(e) {
    console.log("toggle");
    this.menuTarget.classList.toggle("d-none");
    this.menuTarget.classList.toggle("show");
  }
  hide(e) {
    console.log("hide");
  }
}
